import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FastingBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-warning bg-transparent text-warning">
      {t('component:badge.fasting')}
    </Badge>
  );
};
